import { MAIN_CATEGORY } from 'Constants/categories';

export const DEFAULT_TOP_LOCATIONS = 10;
export const config = [
    {
        categoryId: MAIN_CATEGORY.HOUSES_FOR_SALE,
        filters: [
            {
                // filter wise config.
                id: 'rooms',
                location: {
                    // selected location type wise config.
                    CITY: {
                        enabled: true,
                        // show interlinks when selected location is city, otherwise hide it.
                        showSelectedLocation: true,
                        // show interlinks only on filter selection
                        showOnFilterSelection: false,
                        // show nearby locations.
                        siblings: false,
                        // Do we need to show L4 location interlinks on selected L3 location?
                        nestedLocation: {
                            // should show nested location or not.
                            enabled: true,
                            // name => Filter Name => eg BHK | Budget
                            // value => Filter Value => eg 1 BHK | 2 BHK
                            heading: 'value',
                            // how many location do we want to show.
                            topLocations: 5
                        },
                        heading: 'filter'
                    },
                    NEIGHBOURHOOD: {
                        enabled: true,
                        showSelectedLocation: false,
                        siblings: true,
                        nestedLocation: {
                            enabled: false,
                            heading: 'value',
                            topLocations: 10
                        }
                    }
                },
                heading: 'BHK Wise Flats For Sale',
                text: '{value} Flats for Sale in {location}'
            }
        ]
    },
    {
        categoryId: MAIN_CATEGORY.HOUSES_FOR_RENT,
        filters: [
            {
                id: 'rooms',
                location: {
                    CITY: {
                        enabled: true,
                        showSelectedLocation: true,
                        showOnFilterSelection: false,
                        siblings: false,
                        nestedLocation: {
                            enabled: true,
                            heading: 'value',
                            topLocations: 5
                        },
                        heading: 'filter'
                    },
                    NEIGHBOURHOOD: {
                        enabled: true,
                        showSelectedLocation: false,
                        siblings: true,
                        nestedLocation: {
                            enabled: false,
                            heading: 'value',
                            topLocations: 10
                        }
                    }
                },
                heading: 'BHK Wise Flats For Rent',
                text: '{value} Flats for Rent in {location}'
            }
        ]
    }
];
